import {
  addToPlayRangeUndoStack,
  redoPlayRangeChange,
  resetPlayRangeUndoStack,
  setSelectedPlayRangeHandle,
  setSelectedPlayRangeIdx,
  undoPlayRangeChange,
  updateShowTrimExitWarning,
} from 'actions/trimming';
import {
  ENTER_TRIM_MODE,
  LEAVE_TRIM_MODE,
  SET_SENDING_NEW_TRIM,
  UPDATE_CURRENT_TRIM_RANGE,
  UPDATE_PLAY_RANGES,
  UPDATE_SELECTED_TRIM_BOUND,
  UPDATE_SELECTED_TRIM_RANGE,
  UPDATE_TRIM_NEW_CHANGES,
  UPDATE_TRIM_ORIGINAL_RANGES,
  UPDATE_TRIM_RANGES,
  UPDATE_TRIM_REDO_STACK,
  UPDATE_TRIM_UNDO_STACK,
} from 'constants/actions';

// all ranges are of the form: {
//   id:   Number(new Date())
//   from: Number(milliseconds),
//   to:   Number(milliseconds)
// }
const DEFAULT_TRIMMING_STATE = {
  current_trim_range: null, // set if currently adding/editing a trim range
  in_trim_mode: false,
  new_changes: false, // if there are new trim changes to publish
  original_ranges: [], // needed to check whether there are new changes to publish
  playRanges: [],
  playRangeUndoPointer: -1,
  playRangeUndoStack: [],
  redo_stack: [],
  selected_trim_bound: null, // which bound is currently active
  selected_trim_range: null, // if a range is clicked and can be deleted
  selectedPlayRangeIdx: null,
  selectedPlayRangeHandle: null,
  sendingNewTrim: false, // when we post trim updates to the server,
  showExitWarning: false,
  showRevertWarning: false,
  trim_ranges: [],
  undo_stack: [],
};

const trimmingState = (state = DEFAULT_TRIMMING_STATE, action) => {
  switch (action.type) {
    case ENTER_TRIM_MODE:
      return {
        ...state,
        in_trim_mode: true,
      };

    case LEAVE_TRIM_MODE:
      return {
        ...DEFAULT_TRIMMING_STATE,
      };

    case UPDATE_CURRENT_TRIM_RANGE:
      return {
        ...state,
        current_trim_range: action.trimRange,
        selected_trim_range: null,
      };

    case UPDATE_SELECTED_TRIM_BOUND:
      return {
        ...state,
        selected_trim_bound: action.trimBound,
      };

    case UPDATE_SELECTED_TRIM_RANGE:
      return {
        ...state,
        selected_trim_range: action.trimRange,
      };

    case UPDATE_TRIM_NEW_CHANGES:
      return {
        ...state,
        new_changes: action.newChanges,
      };

    case UPDATE_TRIM_ORIGINAL_RANGES:
      return {
        ...state,
        original_ranges: action.originalRanges,
      };

    case UPDATE_TRIM_RANGES:
      return {
        ...state,
        current_trim_range: null,
        selected_trim_range: null,
        trim_ranges: action.trimRanges,
      };

    case UPDATE_TRIM_REDO_STACK:
      return {
        ...state,
        redo_stack: action.redoStack,
      };

    case UPDATE_TRIM_UNDO_STACK:
      return {
        ...state,
        undo_stack: action.undoStack,
      };

    case SET_SENDING_NEW_TRIM:
      return {
        ...state,
        sendingNewTrim: action.sendingNewTrim,
      };

    case UPDATE_PLAY_RANGES:
      return {
        ...state,
        playRanges: action.playRanges,
      };

    case setSelectedPlayRangeIdx.toString():
      if (state.selectedPlayRangeIdx !== action.payload) {
        return {
          ...state,
          selectedPlayRangeIdx: action.payload,
          selectedPlayRangeHandle: null,
        };
      }

      return state;

    case setSelectedPlayRangeHandle.toString():
      return {
        ...state,
        selectedPlayRangeHandle: action.payload,
      };

    case addToPlayRangeUndoStack.toString():
      return {
        ...state,
        playRangeUndoStack: [
          ...state.playRangeUndoStack.slice(0, state.playRangeUndoPointer + 1),
          action.payload,
        ],
        playRangeUndoPointer: state.playRangeUndoPointer + 1,
      };

    case resetPlayRangeUndoStack.toString():
      return {
        ...state,
        playRangeUndoPointer: 0,
        playRangeUndoStack: [action.payload],
      };

    case undoPlayRangeChange.toString():
      if (state.playRangeUndoStack[state.playRangeUndoPointer - 1]) {
        return {
          ...state,
          playRanges: [
            ...state.playRangeUndoStack[state.playRangeUndoPointer - 1],
          ],
          playRangeUndoPointer: state.playRangeUndoPointer - 1,
        };
      }

      return state;

    case redoPlayRangeChange.toString():
      if (state.playRangeUndoStack[state.playRangeUndoPointer + 1]) {
        return {
          ...state,
          playRanges: [
            ...state.playRangeUndoStack[state.playRangeUndoPointer + 1],
          ],
          playRangeUndoPointer: state.playRangeUndoPointer + 1,
        };
      }

      return state;

    case updateShowTrimExitWarning.toString():
      return {
        ...state,
        showExitWarning: action.payload,
      };

    default:
      return state;
  }
};

export default trimmingState;
